import React from "react";

import "./testimonial.scss";

const Testimonial = () => {
  return (
    <section id="testimonials" className="testimonials">
      <div className="container">
        <h1 className="testimonialsHeader">Testimonials</h1>
        <div className="testimonialsAll">
          <div className="testimonialsDetails">

            <h1>Emily Sikora</h1>
            <p>
              "The wood-fired pizza here is simply the best I've ever tasted! The crust is perfect and the ingredients are so fresh. Highly recommended if you really love authentic pizza!"
            </p>
          </div>

          <div className="testimonialsDetails">

            <h1>Michael Smith</h1>
            <p>
              "Amazing pizza and great service! The chef really knows his craft—over ten years of experience and it shows in every bite!"
            </p>
          </div>

          <div className="testimonialsDetails">

            <h1>María Barrantes</h1>
            <p>
              "La pizza a la leña de El Rinconcito es deliciosa todos en Fortuna lo saben. Demasiado buenas! Me encanta especialmente la Lomito"
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
